import React, {Component} from 'react';
import t from 'tcomb-form';
import classNames from 'classnames';

/**
 * Don't you dare reuse this
 */
class FormNumberInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            hasError: false
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.value !== this.state.value) {
            this.props.onChange(this.state.value, this.props.ctx.path);
        }
    }

    getValidationOptions = () => ({
        path: this.props.ctx.path,
        context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
            options: this.props.options
        })
    });

    removeErrors() {
        this.setState({hasError: false});
    }

    validate = () => {
        const {value} = this.state;
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    };

    /**
     * @param {Event} e
     * @memberof FormNumberInput
     */
    handleChange = e => {
        const value = parseInt(e.target.value, 10);

        if (!Number.isNaN(value)) {
            this.setState({value});
        }
    };

    isValueNully() {
        return this.state.value === null;
    }

    render() {
        const {hasError, value} = this.state;
        const {options, ctx} = this.props;
        const label = options.label || ctx.label;

        return (
            <div>
                <label className={classNames('control-label', hasError && 'has-error')}>
                    {label}
                </label>

                <input
                    style={{padding: '1rem'}}
                    id="number"
                    type="number"
                    name={ctx.name}
                    value={value}
                    className="form-control"
                    onChange={this.handleChange}
                />
            </div>
        );
    }
}

export default FormNumberInput;



// WEBPACK FOOTER //
// ./form_components/form_number_input/index.js